import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const filled = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <div className="w-full" data-id="element-237" data-mp="2l4o1p39evveh">
      <p className="flex items-center justify-center gap-2 text-center text-[15px] font-bold text-ink" data-id="element-238" data-mp="2q40zgj1tmmvu">
        <FlameIcon className="h-5 w-5 shrink-0 text-red-600" aria-hidden="true" data-id="element-239" data-mp="2b6qhcquoair5" />
        Only <span className="text-red-600" data-id="element-240" data-mp="2b934difafjb2">{SPOTS_LEFT} spots left</span> at the promotional price
      </p>
      <div className="mt-3 h-5 w-full overflow-hidden rounded-full bg-ink/10" role="progressbar" aria-valuenow={Math.round(filled)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-241" data-mp="2261zfl25ry8z">
        <motion.div className="flex h-full items-center justify-end rounded-full bg-red-600 pr-2.5" initial={{
        width: '60%'
      }} whileInView={{
        width: `${filled}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-242" data-mp="f8hws8m16yc">
          <span className="text-[11px] font-extrabold text-white" data-id="element-243" data-mp="2zl1cwuezn5ej">{Math.round(filled)}% claimed</span>
        </motion.div>
      </div>
    </div>;
}